// src/App.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Layout from "./components/Layout";

//  — Páginas
import Home                 from "./pages/Home";
import AcercaDe             from "./pages/AcercaDe";
import HomeImpresion        from "./pages/HomeImpresion";
import HomeAltas            from "./pages/HomeAltas";
import Login                from "./pages/Login";
import Admin                from "./pages/Admin";
import Clientes             from "./pages/Clientes";
import Proveedores          from "./pages/Proveedores";
import Comandas             from "./pages/Comandas";
import Transportes          from "./pages/Transportes";
import Choferes             from "./pages/Choferes";
import Camiones             from "./pages/Camiones";
import Estaciones           from "./pages/Estaciones";
import Productos            from "./pages/Productos";
import Localidades          from "./pages/Localidades";
import Empresas             from "./pages/Empresas";
import Destinos             from "./pages/Destinos";
import Estados              from "./pages/Estados";
import Observas             from "./pages/Observas";
import Gastos               from "./pages/Gastos";
import CuentaGastos         from "./pages/CuentaGastos";
import Imputas              from "./pages/Imputas";
import Metodos              from "./pages/Metodos";
import Movimientos          from "./pages/Movimientos";
import Viajes               from "./pages/Viajes";
import Remitos              from "./pages/Remitos";
import Remitocs             from "./pages/Remitocs";
import Cajas                from "./pages/Cajas";
import Lotes                from "./pages/Lotes";
import Personas             from "./pages/Personas";
import InformeComandas      from "./pages/InformeComandas";
import InformeRemitos       from "./pages/InformeRemitos";
import InformeRemitocs      from "./pages/InformeRemitocs";
import InformeCajas         from "./pages/InformeCajas";
import InformeMovimientos   from "./pages/InformeMovimientos";
import InformeRendiciones   from "./pages/InformeRendiciones";
import InformeOrdenCobro    from "./pages/InformeOrdenCobro";
import InformeOrdenPago     from "./pages/InformeOrdenPago";
import InformeCartera       from "./pages/InformeCartera";
import InformeTesoreria     from "./pages/InformeTesoreria";
import InformeCliPro        from "./pages/InformeCliPro";
import InformeCtaCte        from "./pages/InformeCtaCte";
import InformeChequesECheq  from "./pages/InformeChequesECheq";
import InformeAjustesCtaCte from "./pages/InformeAjustesCtaCte";
// import Rendiciones          from "./pages/InformeRendiciones";
// — util
const isLoggedIn = () => !!localStorage.getItem("token");

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn() ? <Component {...props} /> : <Redirect to="/login" />
    }
  />
);

export default function App() {
  return (
    <Router>
      <Layout>
        <Switch>
          {/* público */}
          <Route exact path="/login" component={Login} />

          {/* privadas */}
          <PrivateRoute exact path="/"                 component={Home} />
          <PrivateRoute exact path="/AcercaDe"         component={AcercaDe} />
          <PrivateRoute exact path="/HomeImpresion"    component={HomeImpresion} />
          <PrivateRoute exact path="/HomeAltas"        component={HomeAltas} />
          <PrivateRoute exact path="/Clientes"         component={Clientes} />
          <PrivateRoute exact path="/Proveedores"      component={Proveedores} />
          <PrivateRoute exact path="/Comandas"         component={Comandas} />
          <PrivateRoute exact path="/Empresas"         component={Empresas} />
          <PrivateRoute exact path="/Destinos"         component={Destinos} />
          <PrivateRoute exact path="/Estados"          component={Estados} />
          <PrivateRoute exact path="/Observas"         component={Observas} />        
          <PrivateRoute exact path="/Gastos"           component={Gastos} />
          <PrivateRoute exact path="/CuentaGastos"     component={CuentaGastos} />
          <PrivateRoute exact path="/Imputas"          component={Imputas} />
          <PrivateRoute exact path="/Metodos"          component={Metodos} />
          <PrivateRoute exact path="/Transportes"      component={Transportes} />
          <PrivateRoute exact path="/Localidades"      component={Localidades} />
          <PrivateRoute exact path="/Choferes"         component={Choferes} />
          <PrivateRoute exact path="/Camiones"         component={Camiones} />
          <PrivateRoute exact path="/Estaciones"       component={Estaciones} />
          <PrivateRoute exact path="/Productos"        component={Productos} />
          <PrivateRoute exact path="/Movimientos"      component={Movimientos} />
          <PrivateRoute exact path="/Cajas"            component={Cajas} />
          <PrivateRoute exact path="/Lotes"            component={Lotes} />
          <PrivateRoute exact path="/Personas"         component={Personas} />
          <PrivateRoute exact path="/Viajes"           component={Viajes} />
          <PrivateRoute exact path="/Remitos"          component={Remitos} />
          <PrivateRoute exact path="/Remitocs"         component={Remitocs} />
          
          {/* informes (en minúscula para coincidir con navbar actualizado) */}
          <PrivateRoute exact path="/informecomandas"       component={InformeComandas} />
          <PrivateRoute exact path="/informeremitos"        component={InformeRemitos} />
          <PrivateRoute exact path="/informeremitocs"       component={InformeRemitocs} />
          <PrivateRoute exact path="/informecajas"          component={InformeCajas} />
          <PrivateRoute exact path="/informemovimientos"    component={InformeMovimientos} />
          <PrivateRoute exact path="/informerendiciones"    component={InformeRendiciones} />
          <PrivateRoute exact path="/informeordencobro"     component={InformeOrdenCobro} />  
          <PrivateRoute exact path="/informeordenpago"      component={InformeOrdenPago} /> 
          <PrivateRoute exact path="/informecartera"        component={InformeCartera} /> 
          <PrivateRoute exact path="/informetesoreria"      component={InformeTesoreria} />       
          <PrivateRoute exact path="/informeclipro"         component={InformeCliPro} />  
          <PrivateRoute exact path="/informectacte"         component={InformeCtaCte} />
          <PrivateRoute exact path="/informe-cheques-echeq" component={InformeChequesECheq } />
          <PrivateRoute exact path="/informeajustesctacte"  component={InformeAjustesCtaCte } />

          {/* admin extra */}
          <PrivateRoute exact path="/admin" component={Admin} />

          {/* catch-all */}
          <Route path="*">
            {isLoggedIn() ? <Redirect to="/" /> : <Redirect to="/login" />}
          </Route>
        </Switch>
      </Layout>
    </Router>
  );
}
